import { Link, useNavigate } from 'react-router-dom';
import React, { ChangeEvent, FormEvent, useState } from 'react';
import { enumToArray, formatCurrency, formatStatus, objectToString } from '../../../../../helpers';
import { PROPERTY_STATUS_ENUM, PROPERTY_TYPE_ENUM, QueryParams } from '../../../../../interfaces';

const Slider = () => {
  const navigate = useNavigate();
  const [queryParams, setQueryParams] = useState<QueryParams>({});

  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setQueryParams(prevState => ({
      ...prevState,
      [name]: value,
    }));
  }

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    navigate('/properties?' + objectToString(queryParams));
  }

  return (
    <div>
      <div id="slider" className="loading has-parallax">
        <div id="loading-icon"><i className="fa fa-cog fa-spin"/></div>
        <div className="owl-carousel homepage-slider carousel-full-width">
          <div className="slide">
            <div className="container">
              <div className="overlay">
                <div className="info">
                  <div className="tag price">{formatCurrency(11000)}</div>
                  <h3>Kirchenallee 64</h3>
                  <figure>Regen, Freistaat Bayern, 94204, Germany</figure>
                </div>
                <hr/>
                <Link to="/properties" className="link-arrow">
                  Read More
                </Link>
              </div>
            </div>
            <img alt="" src="/assets/img/slide-01.jpg"/>
          </div>
          <div className="slide">
            <div className="container">
              <div className="overlay">
                <div className="info">
                  <div className="tag price">{formatCurrency(16000)}</div>
                  <h3>48 Quai des Belges</h3>
                  <figure>Massy, Île-de-France, 91300, France</figure>
                </div>
                <hr/>
                <Link to="/properties" className="link-arrow">Read More</Link>
              </div>
            </div>
            <img alt="" src="/assets/img/slide-02.jpg"/>
          </div>
          <div className="slide">
            <div className="container">
              <div className="overlay">
                <div className="info">
                  <div className="tag price">{formatCurrency(28500)}</div>
                  <h3>Oijärventie 51</h3>
                  <figure>Pello, Lapland, 95700, Finland</figure>
                </div>
                <hr/>
                <Link to="/properties" className="link-arrow">Read More</Link>
              </div>
            </div>
            <img alt="" src="/assets/img/slide-03.jpg"/>
          </div>
        </div>
      </div>
      <div className="search-box-wrapper">
        <div className="search-box-inner">
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-md-offset-9 col-sm-4 col-sm-offset-8">
                <div className="search-box map">
                  <form onSubmit={onSubmit} className="form-map form-search">
                    <h2>Search Your Property</h2>
                    <div className="form-group">
                      <select name="status" style={{ width: '100%' }}
                              defaultValue={queryParams.status}
                              onChange={onChange}>
                        <option value="">Status</option>
                        {enumToArray(PROPERTY_STATUS_ENUM)
                          .map((status, i) => (
                            <option key={i} value={status}>{formatStatus(status)}</option>
                          ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <select name="type" style={{ width: '100%' }}
                              defaultValue={queryParams.type} onChange={onChange}>
                        <option value="">Property Type</option>
                        {enumToArray(PROPERTY_TYPE_ENUM).map((type, i) => (
                          <option key={i} value={type}>{formatStatus(type)}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <input type="text" className="form-control" name={"country"}
                             id="country" value={queryParams.country} onChange={onChange}
                             placeholder={'Country'}/>
                    </div>
                    <div className="form-group">
                      <input type="text" className="form-control" name={"city"}
                             id="city" value={queryParams.city} onChange={onChange}
                             placeholder={'City'}/>
                    </div>
                    <div className="form-group">
                      <input type="text" className="form-control" name={"district"}
                             id="district" value={queryParams.district} onChange={onChange}
                             placeholder={'District'}/>
                    </div>
                    <div className="form-group">
                      <button type="submit" className="btn btn-default">Search Now</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Slider;